<template>
  <div class="desktop-version"  v-loading="loading">
    <div class="u-mt2 u-mb4">
      <span v-if="version"> <span class="u-text--light u-text--sm">Version on production site:</span> <el-tag>{{version}}</el-tag></span>
      <span v-if="!version">Cannot fetch production version</span>
    </div>
    <div class="u-mb5"><a :href="url" target="_blank">{{url}}</a></div>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'

  export default {
    name: 'ba-desktop-version',
    props: ['companyId'],
    data () {
      this.load_version()
      return {
        version: '',
        url: '',
        loading: true,
      }
    },
    methods: {
      async load_version () {
        let url = config.url + `/company/${this.companyId}/builds/version/desktop/`
        try {
          let response = await axios.get(url)
          this.version = response.data.version
          this.url = response.data.url
        } finally {
          this.loading = false
        }
      }
    },
  }
</script>
